import { render, staticRenderFns } from "./myMsg.vue?vue&type=template&id=e9bb0d5e&scoped=true&"
import script from "./myMsg.vue?vue&type=script&lang=js&"
export * from "./myMsg.vue?vue&type=script&lang=js&"
import style0 from "./myMsg.vue?vue&type=style&index=0&id=e9bb0d5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bb0d5e",
  null
  
)

export default component.exports